import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { WFH_STATUS_COLORS, WFH_STATUS_LABELS } from '../constants';

const WfhStatusBadge = ({ status }) => (
  <Chip label={WFH_STATUS_LABELS[status] || status} color={WFH_STATUS_COLORS[status] || 'default'} size="small" />
);

WfhStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default WfhStatusBadge;
